import { GridCellParams, GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useImmer } from "use-immer";
import DataTable from "../../DataGrid/DataGrid";
import axios from "axios";
import { APP_BASE_URL, MCDO_EMPLOYEE_BIODATA } from "../../../Common/EndPoints";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { extractFilters, findDifferenceInArray } from "../helpers";
import toast from "react-hot-toast";
import { employeeBiodataFixedColumns } from "./EmployeeBiodata";

const classNames = (params: GridCellParams) => {
  const field = params.field;
  if (params.row?.difference?.includes(field)) {
    return "highlight";
  }
  return "";
};

const employeeBiodataHistoryFixedColumns: GridColDef[] = [
  {
    field: "created_ts",
    headerName: "Last Updated On",
    sortable: true,
    minWidth: 190,
    hideable: true,
    flex: 1,
    valueGetter: (row) => {
      const value = row.value;
      return value ? moment(value).format("DD-MM-YYYY hh:mm:ss") : "-";
    },
  },
  ...employeeBiodataFixedColumns.map((col) => ({
    ...col,
    cellClassName: classNames,
  })),
];

type IInitialState = {
  data: any[];
  totalElements: number;
};

const initialState: IInitialState = {
  data: [],
  totalElements: 0,
};

function EmployeeBiodataHistory() {
  const { id: biodataId } = useParams();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [employeeBiodataHistoryTableLoader, setEmployeeBiodataHistoryTableLoader] = useState(false);
  const [initialHiddenColumns, setIntialHiddenColumns] = useState({});
  const [state, setState] = useImmer(initialState);

  const employeeBiodataTableColumns = useMemo(() => employeeBiodataHistoryFixedColumns, []);

  const getEmployeeBiodataHistory = async () => {
    try {
      let _filter: any = { page, pageSize, withHistory: true, id: biodataId };
      _filter = extractFilters(_filter);
      setEmployeeBiodataHistoryTableLoader(true);
      let url = `${APP_BASE_URL}${MCDO_EMPLOYEE_BIODATA}?${_filter}`;
      const res = await axios.get(url);
      const sortedData = (res.data.data.content || []).sort((a: any, b: any) => b.created_ts - a.created_ts);
      setState((state) => {
        state.data = findDifferenceInArray(sortedData);
        state.totalElements = res.data.data?.totalElements || 0;
      });
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong! Try again later!");
        return;
      }
      toast.error(error?.message || "Something went wrong! Try again later!");
      setState((state) => {
        state.data = [];
        state.totalElements = 0;
      });
    } finally {
      setEmployeeBiodataHistoryTableLoader(false);
    }
  };

  useEffect(() => {
    getEmployeeBiodataHistory();
  }, [page, pageSize]);
  return (
    <div className="page-container--card">
      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        Employee Updates History
      </Typography>
      <DataTable
        tableInfo={{
          id: `employee-biodata-history-table`,
          label: `Employee-Biodata-History`,
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}
        loading={employeeBiodataHistoryTableLoader}
        rows={state.data}
        columns={employeeBiodataTableColumns}
        pageSize={pageSize}
        pageIndex={page}
        rowCount={state.totalElements}
        pageChange={setPage}
        pageSizeChange={setPageSize}
        onRowClick={() => {}}
        columnVisibilityModel={initialHiddenColumns}
        rowColor={(params: any) => {
          return params.row.testMode ? "changeRowColor" : "";
        }}
      />
    </div>
  );
}

export default EmployeeBiodataHistory;
